export default [

     {
          path: '/grade',
          name: 'Grade',
          component: () => import("@/views/Page/Grade/Grade.vue"),
           meta: {
               title: '#Default# | Grade',
          },
     }
];